<template>
  <div id="editUserContainer">
    <user :user-id="this.$route.params.id" />
  </div>
</template>

<script>
import User from './User'
export default {
  components: {
    User
  }
}
</script>
